module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "part",
    attrs: {
      "id": "pt01"
    }
  }, [_c('div', {
    staticClass: "partHead",
    attrs: {
      "id": "ph01"
    }
  }, [_c('h2', {
    staticClass: "partNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Part I")])]), _vm._v(" "), _c('h2', {
    staticClass: "partTitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Shining Light and the Huddled Masses")])]), _vm._v(" "), _c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    staticClass: "epubimage",
    attrs: {
      "alt": "image",
      "height": "373",
      "id": "img2",
      "src": "23.jpg",
      "width": "296"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Lillian Gish in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Birth of a Nation")])])])]), _vm._v(" "), _c('div', {
    staticClass: "partBody"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e0d2c4fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781466827714_pt01.vue
// module id = 81
// module chunks = 0